import React from "react";
import { Input } from "@/components/ui/input";
import { useOrganizationStore } from "@/store/organizationStore";

interface EmailInputWithSlugProps {
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
}

export const EmailInputWithSlug: React.FC<EmailInputWithSlugProps> = ({
  value,
  onChange,
  disabled = false,
  placeholder = "agent",
  className,
}) => {
  const organization = useOrganizationStore((state) => state.organization);
  const slug = organization?.slug || "organization";

  return (
    <div className="flex items-center gap-1">
      <Input
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        className={className}
      />
      <span className="text-sm text-muted-foreground whitespace-nowrap">
        -{slug}@m.forgepoint.ai
      </span>
    </div>
  );
};
